import { createSlice } from '@reduxjs/toolkit';

import { denormalizeAssetData } from '../util/data';

const JOURNAL_PAGE_PATH = 'content/pages/journal.json';

const journalCardsSlice = createSlice({
  name: 'journalCards',
  initialState: {
    data: null,
  },
  reducers: {
    setJournalPage: (state, action) => {
      state.data = action.payload;
    },
  },
});

const { setJournalPage } = journalCardsSlice.actions;

/**
 * Loads the Journal index page so an article can reuse its story cards.
 * A missing journal asset leaves the related row empty and does not fail the article.
 */
export const fetchJournalPage = () => (dispatch, getState, sdk) => {
  const version = getState()?.hostedAssets?.version;
  const request = version
    ? sdk.assetByVersion({ path: JOURNAL_PAGE_PATH, version })
    : sdk.assetByAlias({ path: JOURNAL_PAGE_PATH, alias: 'latest' });

  return request
    .then(response => {
      dispatch(setJournalPage(denormalizeAssetData(response.data)));
    })
    .catch(() => null);
};

export default journalCardsSlice.reducer;
